// src/lib/sectorMeta.js
export const SECTOR_LABELS = {
  AGR: "Agriculture",
  IND: "Industry",
  RES: "Residential",
  COM: "Commercial",
  TRA: "Transport",
  ELC: "Power Generation",
  HYG: "Hydrogen",
  WST: "Waste",
  CDR: "Carbon removal",
  FOOD: "Food"
};

// src/lib/sectorMeta.js
export const SECTOR_CONFIG = {
  ELC: { label: "Power Generation",        slug: "power" },
  IND: { label: "Industry & Manufacturing", slug: "industry" },
  TRA: { label: "Transport",                slug: "transport" },
  AGR: { label: "Agriculture",              slug: "agriculture" },
  OTH: { label: "Other",                    slug: "other" },
  RES: { label: "Buildings & Homes",        slug: "residential" },
  SER: { label: "Services",                 slug: "commercial" },

};

// exact display order you asked for
export const SECTOR_ORDER = ["ELC", "IND", "TRA",  "RES", "OTH"];

const PALETTE = [
  "#2563eb", "#16a34a", "#f59e0b", "#dc2626",
  "#7c3aed", "#0ea5e9", "#ea580c", "#059669",
  "#a855f7", "#22c55e", "#f97316", "#ef4444",
];

export const SECTOR_COLOURS = {
  AGR: "#16a34a",
  IND: "#f59e0b",
  RES: "#2563eb",
  COM: "#7c3aed",
  TRA: "#dc2626",
  OTH: "#dc2626",
  ELC: "#0ea5e9",
  HYG: "#059669",
  WST: "#ea580c",
  CDR: "#a855f7",
  FOOD: "#8b5cf6",
};

// Deterministic fallback for unknown codes
const hash = (s) => [...String(s)].reduce((a, c) => (a * 33 + c.charCodeAt(0)) >>> 0, 5381);
export const getSectorLabel = (code) => SECTOR_LABELS[code] ?? String(code);
export const getSectorColour = (code) => SECTOR_COLOURS[code] ?? PALETTE[hash(code) % PALETTE.length];

